/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Bad_Gopher_NudgeInputs */

const en_legal_bad_gopher_nudge = /** @type {(inputs: Legal_Bad_Gopher_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Legal_Bad_Gopher_NudgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const legal_bad_gopher_nudge = /** @type {((inputs?: Legal_Bad_Gopher_NudgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Bad_Gopher_NudgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_legal_bad_gopher_nudge(inputs)
});